import React from 'react'
import GenieTabs from '../features/dashboard/GenieTabs'
import { shallow, mount } from 'enzyme'

describe('<GenieTabs />', () => {
  let wrapper, props
  describe('#render', () => {
    beforeEach(() => {
      const tabs = new Map([
        ['relationship_manager', 'Relationship Manager'],
        ['loan_specialist', 'Loan Specialist'],
        ['account_manager', 'Account Manager']
      ])
      props = {
        tabs,
        changeRole: jest.fn(),
        currentRole: 'relationship_manager'
      }
      wrapper = shallow(<GenieTabs {...props} />)
    })
    it('should render without crashing', () => {
      expect(wrapper).toBeTruthy()
    })
    it('should render one tab per entry in its `tabs` prop', () => {
      expect(wrapper.find('GenieTab')).toHaveLength(props.tabs.size)
    })
    it('should call its changeRole function with the correct key when is clicked', () => {
      wrapper = mount(<GenieTabs {...props} />)
      wrapper.find('GenieTab__Tab').at(0).simulate('click')
      expect(props.changeRole).toHaveBeenCalledTimes(1)
      expect(props.changeRole).toHaveBeenCalledWith('relationship_manager')
    })
  })
})
